import React from "react";
import { html } from "lit";
import parse from 'html-react-parser';
import { sortNumber, sortObjects } from "omni-ui";

// AG Grid imports
import { AgGridReact } from "ag-grid-react";
import {
    AllCommunityModule, 
    ModuleRegistry, 
    ClientSideRowModelModule, 
    ValidationModule, 
    NumberEditorModule, 
    DateFilterModule, 
    NumberFilterModule, 
    TextFilterModule, 
    CustomFilterModule, 
    CsvExportModule, 
    RowSelectionModule
} from "ag-grid-community";
import { 
    TreeDataModule, 
    ColumnsToolPanelModule, 
    FiltersToolPanelModule, 
    PivotModule,
    SetFilterModule, 
    StatusBarModule, 
    ExcelExportModule,
    LicenseManager
} from "ag-grid-enterprise";

// Shared components and utilities
import { 
    NoDataComponent, 
    AlertMessagesService, 
    OmniSearchComponent, 
    OmniTableComponent, 
    OmniToolbarComponent, 
    OmniTooltipNextComponent, 
    OmniIconComponent, 
    tableUtils as TableUtils, 
    MediaOpsService 
} from "../../../../shared";

// Feature imports
import { PlacementFilterComponent, PlacementDetailsTableService } from "../../../placements";
import { CreateCreativeService } from "../../";

// Local imports
import OrphanedFilterComponent from "./orphanedFilterComponent";
import OrphanedDeliveredModelComponent from "./orphanedDeliveredDialogComponent";
import { AGGRID_LICENCE_KEY, Utils } from "../../../../shared";

ModuleRegistry.registerModules([
    TreeDataModule,
    AllCommunityModule,
    ValidationModule,
    NumberEditorModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    PivotModule,
    SetFilterModule,
    ClientSideRowModelModule,
    DateFilterModule,
    NumberFilterModule,
    TextFilterModule,
    StatusBarModule,
    CustomFilterModule,
    CsvExportModule,
    ExcelExportModule,
    RowSelectionModule
]);

LicenseManager.setLicenseKey(AGGRID_LICENCE_KEY);
export default class OrphanedDeliveredObjectsComponent extends React.Component {

    defaultState = {
        isModelOpen: false,
        orphanedTableData: [],
        placementTableData: [],
        creativePlacementData: [],
        enableMapToObject: true,
        saveBtnToastMessageData: [],
        filterDropdownOptions: {
            channel: [],
            campaign: [],
        },
        isOrphanedTableLoading: false,
        isPlacementTableDataLoading: false,
        sort: {orphanedSort:{ key: '', dir: '' }, placementSort:{ key: '', dir: '' }},
        orphanedDataArray: [],
        disableUnMap: true,
        selectAllCreatives: 'none',
    };

    componentIsMounted = true;
    mappingObjects = [];
    campaignDropdownOptions = [];
    placementDropdownOptions = [];

    constructor(props) {
        super(props);
        this.state = this.defaultState;
        this.creativeGridRef = React.createRef();
        this.creativePlacementGridRef = React.createRef();
    }

    componentDidMount() {
        if(this.componentIsMounted){
            this.componentIsMounted = false;
            if(this.props.isCreative){
                this.fetchCreatives();
            } else {
                this.fetchOrphanedDeliveredData();
            }
            this.props.setSpinnerCount(0)

            if (this.props?.state?.campaignObj?.campaign_name) {
            this.props.setCampaignName(Utils.formatCampaignTitle(this.props.state.campaignObj));
            this.setState({ filterDropdownOptions: {...this.state.filterDropdownOptions, campaign:[this.props?.state?.campaignObj.campaign_name]} });
                        this.fetchPlacementTableData(null, this.props.placementsData);
            } else {
                this.loadCampaignData();
            }
        }
    };

    /**
     * Loads campaign data by campaign ID and initializes component state for orphaned delivered objects.
     * 
     * This method is called when campaign object data is not available in props.state. It fetches 
     * campaign details using the campaign ID from URL parameters, updates the component state with 
     * campaign information, sets up filter dropdown options, and triggers placement table data loading.
     * 
     */
    loadCampaignData = () => {
        this.props.setSpinnerCount(1);
        const { campaignId } = this.props.params;
        MediaOpsService.getCampaignDataById(campaignId, '', this.props?.versionOneApi)
            .then((response) => {
                let campaignObj = response[0];
                this.props.setCampaignName(Utils.formatCampaignTitle(campaignObj));
                this.setState({ filterDropdownOptions: { ...this.state.filterDropdownOptions, campaign: [campaignObj?.campaign_name] } });
                this.props.location.state = { campaignObj: campaignObj };
                this.fetchPlacementTableData(null, this.props.placementsData);
            })
            .catch((error) => {
                AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.loadCampaignData(), title: 'Campaign API cannot be loaded', bodyMsgArr: [] }]);
            })
            .finally(() => {
                this.props.setSpinnerCount(0);
            });
    };

    /**
     * Display the skeleton table
     * @returns {void}
     */
    displaySkeletonTable() {
        let rows = '';
        for (let i = 0; i < 10; i++) {
            rows = rows + '<div className="table skeleton"></div>';
        }
        rows = (html`${rows}`);
        return <>{parse(rows.values[0])}</>;
    }

    /**
     * Update the sort column for the table data 
     * @param {Object} event
     */
    updateSortColumn = (event) => {   
        if(event.detail.sort.key === 'taxonomy_name'){
            let sortedData = [...this.state.orphanedTableData]
            Object.assign(this.state.sort['orphanedSort'], event.detail.sort);
            if (event.detail.sort.dir === 'asc') {
                sortedData = sortObjects(this.state.orphanedTableData, event.detail.sort.key, (a, b) => sortNumber(a[event.detail.sort.key], b[event.detail.sort.key]));
            } else if (event.detail.sort.dir === 'desc') {
                sortedData = this.state.orphanedTableData.reverse();
            }
            this.setState({ orphanedTableData: sortedData });
        }else{
            let sortedData = [...this.state.placementTableData]
            Object.assign(this.state.sort['placementSort'], event.detail.sort);
            if (event.detail.sort.dir === 'asc') {
                sortedData = sortObjects(this.state.placementTableData, event.detail.sort.key, (a, b) => sortNumber(a[event.detail.sort.key], b[event.detail.sort.key]));
            } else if (event.detail.sort.dir === 'desc') {
                sortedData = this.state.placementTableData.reverse();
            }
            this.setState({ placementTableData: sortedData });
        }
    }

    /**
     * Handle the unmapping of the orphaned delivered data to the placement
     * @param {number} placement_id
     * @returns {void}
     */
    handleUnmapped = (taxonomy_value_id, status) => {
        this.props.setSpinnerCount(1);
        const payload = {mapping: [{id: taxonomy_value_id.toString(), map: false, status}]}
        MediaOpsService.mapOrphanedDeliveredData(payload)
        .then((response) => {
            this.props.setSpinnerCount(0);
            this.fetchPlacementTableData();
            this.fetchOrphanedDeliveredData();
            this.setState({ saveBtnToastMessageData: [...this.state.saveBtnToastMessageData, 'unmapped'] });
            AlertMessagesService.showSuccessToastMessage('You have successfully unmapped Orphaned Delivered objects!');
        }).catch((error) => {
            this.props.setSpinnerCount(0);
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.handleUnmapped(taxonomy_value_id, status), title: 'Unable to unmapping to the placement', bodyMsgArr: []}]);
        });
    }

    /**
     * Fetch the orphaned delivered data from the API
     * @param {string} options
     * @param {string} type
     * @returns {void}
     */
    fetchOrphanedDeliveredData = (options, type) => {
        this.mappingObjects = [];
        this.setState({ isOrphanedTableLoading: true });
        const params = { is_orphan: true, campaign_id: this.props?.state?.campaignObj?.amd_campaign_id };
        MediaOpsService.getOrphanedDeliveredData(params)
        .then((response) => {
            this.setState({orphanedDataArray: response.data});
            if(options){
                if(type === 'search'){
                    const data = response.data.filter((item) => item.taxonomy_value.toLowerCase().includes(options.toLowerCase()));
                    this.createOrphanedNestedData(data, 'search');
                }else if (type === 'filter'){
                    let filterData = response.data;
                    if(options.channel){
                        filterData = filterData.filter((item) => options.channel.includes(item.site ? item.site.toUpperCase() : 'UNASSIGNED'));
                    }
                    if(options.vendor){
                        filterData = filterData.filter((item) => item.taxonomy_value.toLowerCase().includes(options.vendor.toLowerCase()));
                    }
                    this.createOrphanedNestedData(options ? filterData : response.data, 'filter');
                }
            }else{
                this.createOrphanedNestedData(response?.data);
            }
        }).catch((error) => {
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.fetchOrphanedDeliveredData(options, type), title: 'Orphaned API cannot be loaded', bodyMsgArr: []}]);
            this.setState({ isOrphanedTableLoading: false });
        });
    }

    createOrphanedNestedData = (data, type) => {
        let newOrphanedData = [];
        if(data.length){
            newOrphanedData = data.reduce((groups, item, index) => {
                const { site, ...rest } = item;
                const siteName = site ? site.toUpperCase() : 'UNASSIGNED';
                if (!groups[siteName]) {
                    groups[siteName] = {
                        "taxonomy_name": siteName,
                        "taxonomy_value": siteName,
                        nestedData: [],
                        _uniqueKey: "parentRow" + index,
                    };
                }

                if (rest?.parent_id) {
                    rest['parent_type'] = data.find((item) => item?.id === Number(rest?.parent_id))?.package_type;
                }

                groups[siteName].nestedData.push({ ...rest });
                return groups;
              }, {});
              
              newOrphanedData = Object.values(newOrphanedData);
        }
        const filterDropdownOptions = ['search', 'filter'].includes(type) ? this.state.filterDropdownOptions : {...this.state.filterDropdownOptions, channel: newOrphanedData.map(item => item.taxonomy_value)};
        this.setState({ orphanedTableData: newOrphanedData, isOrphanedTableLoading: false, filterDropdownOptions});
    };

    /**
     * Fetch the placement table data from the API
     * @param {string} options
     * @returns {void}
     */
    fetchPlacementTableData = (options, data, isTableLoad = true) => {
        this.setState({ isPlacementTableDataLoading: isTableLoad });
        if(data && data.length){
            if(!this.props.isCreative) {
                this.createPlacementNestedData(data);
                this.placementDropdownOptions = data.map(item => {return {value:item.placement_taxonomy, id:item.id, placements_id: item.placements_id, parent_id: item.parent_id}});
            } else {
                this.createCreativePlacementData(data);
            }
        }else{
            options = {...options, page_no: 1, page_size: 2500};
            this.getPlacementData(options);
        }
    }

    getPlacementData = (options,totalPlacementData = [], hasNextAPI = null) => {
        PlacementDetailsTableService.getPlacementsWithDelivered(this.props?.state?.campaignObj?.id || this.props?.location?.state?.campaignObj?.id, options, this.props?.versionOneApi,hasNextAPI)
        .then(response => {
            totalPlacementData.push(...response?.data?.Items);
            let hasNext = response?.data?.paging?.next;
            if(!hasNext){
                if(totalPlacementData.length){
                    if(!this.props.isCreative) {
                        this.createPlacementNestedData(totalPlacementData);
                        this.placementDropdownOptions = totalPlacementData.map(item => {return {value:item.placement_taxonomy, id:item.id, placements_id: item.placements_id, parent_id: item.parent_id}})
                    } else {
                        this.createCreativePlacementData(totalPlacementData);
                    }
                }else{
                    this.setState({ placementTableData: [],  selectAllCreatives: 'none', disableUnMap: true});
                }
            }else {
                this.getPlacementData(options,totalPlacementData,hasNext);
            }
        }).catch(error => {
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.fetchPlacementTableData(options, data), title: 'Placement API cannot be loaded', bodyMsgArr: []}]);
            this.setState({ isPlacementTableDataLoading: false });
        });
    }
    /**
     * Create the placement nested data from the API response data
     * @param {array} placementsData
     * @returns {void}
     */
    createPlacementNestedData = (placementsData) => {
        if(this.props.isCreative){
            placementsData = this.setCreativeData(placementsData);
        }
        const newPlacementsData = placementsData.map((item)=>{
            return {...item, nestedData:item.delivered_taxonomies}
        })
        // Group data by "placement_type"
        const typeGroups = newPlacementsData.reduce((groups, item, index) => {
            if (!groups[item.placement_type]) {
                groups[item.placement_type] = {
                    "placement_taxonomy": item.placement_type || 'Unassigned',
                    title: "Channel",
                    type: "",
                    provider: "",
                    nestedData: [],
                    level: 0,
                    index: index,
                    override_taxonomy: item.override_taxonomy,
                    _uniqueKey: "parentRow" + index,
                };
            }
            groups[item.placement_type].nestedData.push(item);
            return groups;
        }, {});
        // Group data by "provider" within each "type" group
        const placementNestedData = Object.values(typeGroups).map((typeGroup, groupIndex) => {
            const siteGroups = typeGroup.nestedData.reduce((groups, item, index) => {
                if (!groups[item?.site?.toUpperCase()]) {
                    groups[item?.site?.toUpperCase()] = {
                        "placement_taxonomy": (item?.site || 'Unassigned')?.toUpperCase(),
                        title: "Publisher",
                        type: "",
                        provider: "",
                        nestedData: [],
                        level: 1,
                        index: index,
                        channel: typeGroup['placement_taxonomy'],
                        export_status: item.export_status,
                        _uniqueKey: "" + index + groupIndex,
                        override_taxonomy: item.override_taxonomy,
                        marginClass: "margin-left-10"
                    };
                }
                
                if(item.package_type === "Child"){
                    let matchedParent = groups[item?.site?.toUpperCase()].nestedData.find(placementObj => placementObj.id === Number(item.parent_id));
                    if(matchedParent?.package_type){
                        item.parent_type = matchedParent?.package_type;
                    }
                    item.marginClass = 'margin-left-40';
                }
                groups[item?.site?.toUpperCase()].nestedData.push(item);
                
                if (item.package_type !== 'Child') {
                    if(item.package_type === 'DSP' || item.package_type === 'Package')
                        item.marginClass = 'margin-left-30';
                    else
                        item.marginClass = item.marginClass ? item.marginClass : 'margin-left-20';
                }

                item["_uniqueKey"] = "childRow" + index + groupIndex;
                item["highlight"] = item?.id && item?.highlight
                return groups;
            }, {});
            typeGroup.nestedData = Object.values(siteGroups);
            return typeGroup;
        });
       
        // filter out the undefined values
        let newData = placementNestedData.filter((item) => item.placement_taxonomy !== undefined).length ? placementNestedData.filter((item) => item.placement_taxonomy !== undefined) : placementNestedData;
        
        newData = PlacementDetailsTableService.removeEmptyNestedData(newData);
        this.campaignDropdownOptions = newData.map(item => {return {value:item.placement_taxonomy, id:item._uniqueKey}})
        this.setState({ placementsData: placementsData, placementTableData: newData, isPlacementTableDataLoading: false, selectAllCreatives: 'none', disableUnMap: true });
    }

    /**
     * Fetch the orphaned delivered data from the API based on the search parameter
     * @param {Object} event
     * @param {string} type
     * @returns {void}
     */
    updateSearch = (event, type) => {
        const searchParam = event.detail.value;
        if(type === 'placement'){
            this.setState({ isPlacementTableDataLoading: true });
            let campaignId = encodeURIComponent(this.props.state.campaignObj.id);
            MediaOpsService.searchPlacements(campaignId, searchParam, this.props?.versionOneApi).then(response => {
                this.setState({ isPlacementTableDataLoading: false });
                this.createPlacementNestedData(response.data);
            }, (error) => { 
                this.setState({ isPlacementTableDataLoading: false });
            });
        } else if (type === 'creative'){
            this.fetchCreatives();
        } else{
            this.fetchOrphanedDeliveredData(searchParam, 'search');
        }
    }

    /**
     * Apply the filter based on the type and options provided
     * @param {string} type
     * @param {Object} options
     * @returns {void}
     */
    applyFilter = (type, options) => {
        if(type === 'placement'){
            options = MediaOpsService.prepareFilterOptions(options);
            this.fetchPlacementTableData(options);
        }else{
            this.fetchOrphanedDeliveredData(options, 'filter');
        }
    }

    /**
     * Close the model and add the message to the state based on the value provided
     * @param {array} value
     */
    closeModel = (value) => {
        if (value && value.length) {
            this.setState({ saveBtnToastMessageData: [...this.state.saveBtnToastMessageData, 'mapped'] });
        }
        this.setState({ isModelOpen: false });
    };

    /**
     * Handle the save button click event and navigate to the previous page and show the success toast message
     * @returns {void}
     */
    handleSaveButton = () => {
        if(this.state.saveBtnToastMessageData.length){
            let message = '';
            if(this.state.saveBtnToastMessageData.every(val => val === 'mapped')){
                message = 'mapped'
            }else if(this.state.saveBtnToastMessageData.every(val => val === 'unmapped')){
                message = 'unmapped'
            }else if (this.state.saveBtnToastMessageData.some(val => val === 'mapped') && this.state.saveBtnToastMessageData.some(val => val === 'unmapped')) {
                message = 'mapped and unmapped'
            }
            AlertMessagesService.showSuccessToastMessage(`You have successfully ${message} Unmapped Delivered objects!`);
        }
        this.props.navigate(-1)
    };

    /**
     * Handle the single map event and open the model to map the orphaned delivered data
     * to the placement based on the value provided and update the state based on the value provided
     * @param {Object} value
     * @returns {void}
     */
    handleSingleMap = (value) => {
        this.mappingObjects = [value];
        this.setState({isModelOpen: true })
    }

    /**
     * Handle the multiple mapping event and open the model to map the
     * orphaned delivered data to the placement based on the value provided
     */
    handleMultipleMapping = () => {
        if(!this.props.isCreative){
            this.setState({isModelOpen: true })
        } else {
            this.mapCreatives();
        }
    }

    getPackageIcon = (value) => {
        if(value?.package_type === 'Package' || value?.package_type === 'ProgrammaticPackage'){
            return html`<omni-icon part="package-icon" class="is-size-4" icon-id="omni:informative:package"/>`
        } else if(value?.package_type === 'DSP' || (value?.package_type === 'Child' && value?.parent_type === 'Package')){
            return html`<omni-icon part="package-icon margin-left-10" class="is-size-4" icon-id="omni:informative:package"/>`
        } else if((value?.parent_type === 'DSP' && value?.package_type === 'Child') || (value?.package_type === 'DirectCreative' && value?.parent_id)){
            return html`<omni-icon part="package-icon package-child-icon margin-left-20" class="is-size-4" icon-id="omni:informative:package"/>`
        }
    }

    /**
     * Handles the change event for a row checkbox.
     * Toggles the checked state of the row and updates the state accordingly.
     *
     * @param {Object} value - The value object representing the row data.
     * @param {number} parentIdx - The index of the parent row.
     */
    onRowCheckboxChange(value, parentIdx) {
        const nestedData = this.state.orphanedTableData;
        value.checked = value.checked === 'all' ? 'none' : 'all';
        TableUtils.traverseNodeForCheckbox(parentIdx, value, nestedData, 'orphaned-delivered-table-selectall', 'orphaned-delivered-table');
        const flat = TableUtils.flattenData(nestedData);
        this.mappingObjects = flat.filter((one) => one.id && (one.checked === 'all' || one.checked === 'some'));
        this.setState({
            enableMapToObject: !flat.some((one) => one.checked === 'all'),
            orphanedTableData: nestedData
        });
    }
    /**
     * Handles the change event for the "Select All" checkbox.
     * Toggles the checked state of all rows and updates the state accordingly.
     */
    onSelectAllCheckboxChange() {
        const nestedData = this.state.orphanedTableData;
        const checkAllKey = 'unmappedTableCheckAll';
        TableUtils[checkAllKey] = TableUtils[checkAllKey] === 'all' ? 'none' : 'all';
        TableUtils.unmappedFlattendedDataCache.clear();
        TableUtils.handleCheckAll(nestedData, 'orphaned-delivered-table');
        const flat = TableUtils.flattenData(nestedData);
        if (TableUtils[checkAllKey] === 'all') {
            this.mappingObjects = flat.filter((one) => one.id && (one.checked === 'all' || one.checked === 'some'));
        } else if (TableUtils[checkAllKey] === 'none') {
            this.mappingObjects = []
        }

        this.setState({
            enableMapToObject: !flat.some((one) => one.checked === 'all'),
            orphanedTableData: nestedData
        });
    }
    
    orphanedLeftColumns = [
        {
            label: html`
            <style>
            :host::part(table-header-select) {
                text-align: end;
                padding-right: 0.6rem;
            }
            :host::part(package-icon) {
                width: 18px;
                height: 18px;
                top: 5px;
                position: relative;
                margin-right:10px;
                --color-icon-lines: var(--icon-primary);
            }
            :host::part(package-child-icon) {
                --color-icon-lines: var(--icon-neutral-default);
                opacity: 30%;
            }
            :host::part(margin-left-28) {
                margin-left: -28px;
            }
            :host::part(margin-left-20) {
                margin-left: 20px;
            }
            :host::part(margin-left-10) {
                margin-left: 10px;
            }
            .expand-wrapper.is-clamped {
              max-width: 100% !important;
            }
            </style>


            <span>
                <omni-checkbox
                id="orphaned-delivered-table-selectall"
                style=" --checkbox-height-width: 18px; --checkbox-border-color: #837f7f;"
                ?checked=${TableUtils.unmappedTableCheckAll === 'all'}
                ?indeterminate=${TableUtils.unmappedTableCheckAll === 'some'}
                @change=${() => this.onSelectAllCheckboxChange()}
                @click=${(event) => { event.stopPropagation() }}
                ></omni-checkbox>
                ${this.props.isCreative ? html`<span part="margin-left-20">CREATIVES</span>` : html`<span part="margin-left-20">OBJECT NAME</span>`}
            <span>`,

            template: (value, index, parentIdx) => {
                return !value.nestedData ? 
                    html`
                    <div part="table-body-cell" part="table-body-cell" id="td-${value.id || (value && value["_hash"])}">
                        <div style="display: flex;">
                            ${this.getPackageIcon(value)}
                            <omni-checkbox
                                id="${value.id}"
                                name="${value.id}"
                                ?checked=${value.checked === 'all'}
                                ?indeterminate=${value.checked === 'some'}
                                @change=${() => { this.onRowCheckboxChange(value, parentIdx) }}>
                            </omni-checkbox>
                        </div>
                    </div>
                    <span part="margin-left-20">${value?.taxonomy_value}</span>` : html`${value?.taxonomy_value}`
            },
            key: 'select',
            isSortable: false,
            passthrough: true,
        }
    ];

    orphanedRightColumns = [
        {
            label: 'Actions',
            key: 'actions',
            passthrough: true,
            template: (value, index) => {
                return !value.nestedData ? html`
                <style>
                :host::part(table-body) {
                    transform-style: flat;
                }
                </style>
                <td part="table-body-cell"><button part="mapButton" class="secondary" @click=${() => this.handleSingleMap(value)}>Map</button></td>`
                : html`<td part="table-body-cell"/>`
            }
        }
    ];

    placementLeftColumns = () => {
        return [{
            key: "id",
            passthrough: true,
            template: (value, index) => {
                const isTitle = ['Channel', 'Publisher'].includes(value.title);
                return html`
                <style>      
                :host::part(package-icon) {
                    width: 18px;
                    height: 18px;
                    top: 5px;
                    position: relative;
                    --color-icon-lines: var(--icon-primary);
                }
                :host::part(package-child-icon) {
                    --color-icon-lines: var(--icon-neutral-default);
                    opacity: 30%;
                }
                :host::part(margin-left-10) {
                    margin-left: 10px;
                }
                :host::part(margin-left-20) {
                    margin-left: 20px;
                }
                </style>
                ${isTitle ? '' : this.getPackageIcon(value)}`
            }
        },
        {
            label: 'PLACEMENT NAME',
            key: 'placement_taxonomy',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                const condition = ['Channel', 'Publisher'].includes(value.title);
                const placementName = value.placement_taxonomy ? value.placement_taxonomy : value.taxonomy_value;
                return html`
                <style>
                :host::part(parent-name-cell) {
                    color: var(--core-color-core-dark-100, #3B3E3F);
                }
                :host::part(margin-left-20) {
                    margin-left: 20px;
                }
                :host::part(margin-left-30) {
                    margin-left: 30px;
                }
                :host::part(margin-left-40) {
                    margin-left: 40px;
                }
                </style>
                <td part="table-body-cell ${condition ? 'parent-name-cell' : ''}"><span part=${value.marginClass ? value.marginClass : ""}>${placementName}</span></td>`
            }
        }];
    }

    placementRightColumns = [
        {
            label: 'Actions',
            key: 'actions',
            passthrough: true,
            template: (value, index) => {            
                const condition = (value.taxonomy_name && !value.package_type) && !['Channel', 'Publisher'].includes(value?.title);
                    if(condition){
                    }
                return condition ? html`
                    <style>
                    :host::part(table-body) {
                        transform-style: flat;
                    }
                    </style>
                    <td part="table-body-cell"><button class="secondary" @click=${()=>this.handleUnmapped(value.taxonomy_value_id, value.status)}>Unmap</button></td>`
                    : html`<td part="table-body-cell"/>`
            }
        }
    ];

    /**CREATIVES FUNCTIONS */

    /**
     * Fetch the creatives data from the API
     * @returns {void}
    */
    fetchCreatives = (isTableLoad = true) => {
        this.setState({ isOrphanedTableLoading: isTableLoad });
        // this.callCreativeAPI(isTableLoad);
        let creativeData = this.props?.creativeData;
        if (creativeData?.length) {
            this.setCreativeList(creativeData);
            this.setState({ isOrphanedTableLoading: false });
        }else{
            this.callCreativeAPI(isTableLoad);
        }
    }
    
    callCreativeAPI = (isTableLoad,totalPlacementData=[],hasNextAPI=null) => {
        let parentId = this.props.state?.campaignObj?.parent_id;
        CreateCreativeService.getCreatives(null, this.props?.params?.campaignId, hasNextAPI, parentId).then((response) => {
            totalPlacementData.push(...response?.data?.Items);
            let hasNext = response?.data?.paging?.next;
            if(!hasNext){
                this.setCreativeList(totalPlacementData);
            }else {
                this.callCreativeAPI(isTableLoad,totalPlacementData,hasNext);
            }
            
        }).catch((error) => {
            AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.fetchCreatives(), title: 'Creatives API cannot be loaded', bodyMsgArr: [] }]);
        }).finally(() => {
            this.setState({ isOrphanedTableLoading: false });
        });
    }
    
    setCreativeList = (data) => {
        let creativeList = [];
        for(let i=0; i<data.length; i++){
            creativeList.push({
                id: data[i].creative_id,
                taxonomy_value: data[i].creative_name,
                isCreative : true
            })
        }
        this.setState({ orphanedTableData: creativeList });
    }
    /**
     * Set the creatives data to the table data
     * @param {array} data
     * @returns {array}
    */ 
    setCreativeData = (data) => {
        return data.map(item => {
            if(item?.creative_id){
                let parent = this.findParent(item, data);
                let creativeData = {
                    id: item?.creative_id,
                    taxonomy_value: item?.creative_name,
                    isCreative: true,
                    parent_id: parent.id,
                    placement_type: parent?.placement_type,
                    site: parent?.site,
                    package_type: "Child",
                    mapId: item?.mapid,
                }
                return creativeData;
            } else return item;
        })
    }

    /**
     * Find the parent of the creative data
     * @param {object} creative
     * @param {array} data
     * @returns {object}
    */ 
    findParent = (creative, data) => {
        for(let i=0;i<data.length;i++){
            if(data[i].placements_id === creative.parent_synthetic_id){
                return data[i];
            }
        }
    }

    /**
     * Map the selected creatives to the selected placement
     * @returns {void}
    */
    mapCreatives = () => {
        this.props.setSpinnerCount(1);
        let selectedCreatives = [];
        for (let i = 0; i < this.mappingObjects.length; i++) {
            for (let j = 0; j < this.selectedCreativePlacements.length; j++) {
                let payloadObj = {
                    "creative_placement_synthetic_id": this.mappingObjects[i].id,
                    "placement_synthetic_id": this.selectedCreativePlacements[j]
                }
                selectedCreatives.push(payloadObj);
            }
        }
        let mapPayload = {
            "campaign_id": this.props?.params?.campaignId,
            "creatives": selectedCreatives
        }
        CreateCreativeService.mapCreative(mapPayload).then((response) => {
            this.fetchPlacementTableData(null, null, false);
            this.fetchCreatives(false);
            AlertMessagesService.showSuccessToastMessage(`You have mapped ${this.mappingObjects.length} creatives to the selected placement!`);
            this.selectedCreatives = [];
            this.selectedCreativePlacements = [];
            this.setState({enableMapToObject: true, disableUnMap: true});
        }).catch((error) => {
            AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: this.mapCreatives, title: `Unable to map ${this.mappingObjects.length} creatives to the selected placement!`, bodyMsgArr: [] }]);
        }).finally(() => {
            this.props.setSpinnerCount(0);
        });

    }

    /**
     * Unmap the creatives from the placements
     * @returns {void}
    */
    unMapCreatives = () => {
        this.props.setSpinnerCount(1);
        const payload = this.selectedCreatives;
        CreateCreativeService.unMapCreative(payload)
        .then((response) => {
            this.selectedCreatives = [];
            this.props.setSpinnerCount(0);
            this.fetchPlacementTableData(null, null, false);
            AlertMessagesService.showSuccessToastMessage('You have successfully unmapped the selected Creatives!');
            this.selectedCreatives = [];
            this.selectedCreativePlacements = [];
            this.setState({enableMapToObject: true, disableUnMap: true});
        }).catch((error) => {
            this.props.setSpinnerCount(0);
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.unMapCreatives(), title: 'Unable to unmap the selected creatives', bodyMsgArr: []}]);
        });
    }

    /**
     * Create the creative placement data from the API response data
     * @param {array} placementData
     * @returns {void}
    */ 
    createCreativePlacementData = (placementData) => {
        let creativeWithPlacementData = [];
        //add unmapped placement data
        for(let i=0;i<placementData.length;i++){
            if(placementData[i].placements_id){
                let creativeData = {
                    "id": placementData[i].placements_id,
                    "placement_id": placementData[i].placements_id,
                    "name": placementData[i].placement_taxonomy,
                    "start_date": placementData[i].flight_start,
                    "end_date": placementData[i].flight_end,
                    "creatives": [{
                        "id": "child" + i,
                        "name": 'Fetching Creatives...',
                        "dummyChild": true
                    }],
                    "channel": placementData[i].placement_type,
                    "supplier": placementData[i].site,
                    "isPlacement": true
                }
                creativeWithPlacementData.push(creativeData);
            }
        }
        this.setState({creativePlacementData: creativeWithPlacementData, isPlacementTableDataLoading: false },  ()=> {
            setTimeout(() => {
                this.creativePlacementGridRef?.current?.api?.refreshCells({ force: true });
                this.creativePlacementGridRef?.current?.api?.collapseAll();
                this.creativePlacementGridRef?.current?.api?.closeToolPanel();
            })
        });
    }

    // Default Column defination for ag-grid
    defaultColDef = {
        flex: 1,
        filter: true,
        wrapText: true,
        floatingFilter: true,
        autoHeight: true,
        suppressHeaderMenuButton: true,
    };

    // Column defination for ag-grid Creative table
    creativeColumnDefs = [
        {
            headerName: "Creatives",
            field: "taxonomy_value",
            filter: "agTextColumnFilter",
        }
    ]

    // Column defination for ag-grid Creative Placement table
    creativePlacementColumnDefs = [
        {
            headerName: "Placement Name",
            field: "name",
            width: 500,
            filter: "agTextColumnFilter",
            showRowGroup: true,
            cellRenderer: 'agGroupCellRenderer',
            cellRendererParams: {
                suppressCount: true,
            },
            cellStyle: params => {
                if (params.data.isCreativeChild) {
                    return {backgroundColor: "#caeaf4", left: 0};
                } else {
                    return { left: 0 };
                }
            }
        },
        {
            headerName: "Channel",
            field: "channel",
            initialHide: true,
            filter: "agTextColumnFilter",
        },
        {
            headerName: "Supplier",
            field: "supplier",
            initialHide: true,
            filter: "agTextColumnFilter",
        },
        {
            headerName: "Start Date",
            field: "start_date",
            initialHide: true,
            filter: "agTextColumnFilter",
            valueFormatter: (params) => {            
                if (!params.value) {
                  return "";
                }
    
                const date = new Date(params.value);
                const month = date.getMonth() + 1;
                const day = date.getDate();
                return `${date.getFullYear()}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}`;
            },
        },
        {
            headerName: "End Date",
            field: "end_date",
            initialHide: true,
            filter: "agTextColumnFilter",
            valueFormatter: (params) => {            
                if (!params.value) {
                  return "";
                }
    
                const date = new Date(params.value);
                const month = date.getMonth() + 1;
                const day = date.getDate();
                return `${date.getFullYear()}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}`;
            },
        },
        {
            headerName: "Placement ID",
            field: "placement_id",
            initialHide: true,
            filter: "agTextColumnFilter",
        }
    ]

    /**
     * Handles the selection of creatives in the creative table.
     * Updates the state of selected creatives and the select all checkbox.
     * Enables or disables the map/unmap button based on the selection.
     * @returns {void}
     */
    onCreativeSelection = () => {
        this.mappingObjects = [];
        this.creativeGridRef.current.api.forEachNode((node) => {
            if (node.isSelected()) {
                this.mappingObjects.push(node.data);
            }
        });
        this.setState({ enableMapToObject: !(this.selectedCreativePlacements.length && this.mappingObjects.length)});
    }

    /**
     * Handles the selection of all creatives in the creative placement table.
     * Updates the state of selected creatives and the select all checkbox.
     * Enables or disables the map/unmap button based on the selection.
    */ 
    selectedCreativePlacements = [];
    selectedCreatives = [];
    onCreativePlacementSelection = () => {
        this.selectedCreativePlacements = [];
        this.selectedCreatives = [];
        this.creativePlacementGridRef.current.api.forEachNode((node) => {
            if (node.isSelected()) {
                if(node.data.isCreativeChild){
                    this.selectedCreatives.push(node.data.mapId);
                }
                if(node.data.isPlacement){
                    this.selectedCreativePlacements.push(node.data.placement_id);
                }
            }
        });
        this.setState({ enableMapToObject: !(this.selectedCreativePlacements.length && this.mappingObjects.length),  disableUnMap: !this.selectedCreatives.length });
    }

    /**
     * Handles the export of the mapped creative placements data to Excel.
     * @returns {void}
    */ 
    exportCreativePlacements = () => {
        this.props.setSpinnerCount(1);
        let campaignId = this.props?.state?.campaignObj?.id;
        CreateCreativeService.exportCreative({"campaign_id": campaignId, "mapped": true}).then((response) => {
            AlertMessagesService.showInfoToastMessage("Preparing your file. We'll let you know when it's ready");
            this.checkJobStatusForExportCreative({"campaign_id": campaignId, "mapped": true}, response.job_id);
            this.props.setSpinnerCount(0);
        }, (error) => {
            AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.exportCreativePlacements({"campaign_id": campaignId, "mapped": true}), title: `Unable to export creatives`, bodyMsgArr: [] }]);
            this.props.setSpinnerCount(0);
        })
        //this.creativePlacementGridRef.current.api.exportDataAsExcel();
    }

    /**
     * Function will call API repeatly to check job status
     * then it will call function on job "completion" that will open download modal
     * @param {Array} selectedItems 
     * @param {Array} pmdsItems 
     * @param {string} jobId 
    */
    checkJobStatusForExportCreative = (payload, jobId) => {
        let jobIdPayload = { jobId: jobId };
        PlacementDetailsTableService.checkExportJobStatus(jobIdPayload)
            .then((response) => {
                if (response.status === "COMPLETED" && response.s3PresignedUrl) {
                    Utils.showDownloadModal(response);

                } else if (response.status === "IN PROGRESS" || response.status === "TRIGGERED") {
                    setTimeout(() => {
                        this.checkJobStatusForExportCreative(payload, jobId);
                    }, 10000);
                } else {
                    AlertMessagesService.showErrorToastMessage("Set up your server to enable file download. Contact your team administrator for assistance.");
                }
            }, (error) => {
                AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.exportCreativePlacements(payload), title: `Unable to export creatives`, bodyMsgArr: [] }]);
            });
    }

    /**
     * Fetch creatives for a given placement.
     * @param {*} placementData 
     * @returns {void}
     */
    loadCreatives = (placementData) => {
        this.props.setSpinnerCount(1);
        CreateCreativeService.getCreativeByPlacementId(placementData.placement_id)
            .then((response) => {
                let creativeList = [];
                for(let i = 0; i < response.data.length; i++){
                    let creativeObj = {
                        "id": response.data[i].creative_id + placementData.placement_id,
                        "mapId": response.data[i].mapid,
                        "placement_id": placementData.placement_id,
                        "name": response.data[i].creative_name,
                        "supplier": response.data[i].supplier,
                        "isCreativeChild": true
                    }
                    creativeList.push(creativeObj);
                }
                let creativePlacementData = [...this.state.creativePlacementData];
                for(let i = 0; i < creativePlacementData.length; i++){
                    if(creativePlacementData[i].placement_id === placementData.placement_id){
                        if(creativeList.length){
                            creativePlacementData[i].creatives = creativeList;
                            creativePlacementData[i].nested = true;
                        } else {
                            creativePlacementData[i].creatives[0].name = 'No mapped creatives found';
                        }
                    }
                }
                this.setState({ creativePlacementData }, () => {
                    setTimeout(() => {
                        this.creativePlacementGridRef?.current?.api?.refreshCells({ force: true });
                        this.creativePlacementGridRef?.current?.api?.closeToolPanel();
                    });
                });
            })
            .catch((error) => {
                AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.loadCreatives(placementData), title: 'Unable to fetch the Creatives', bodyMsgArr: []}]);
            }).finally(() => {
                this.props.setSpinnerCount(0);
            });
    }

    /**
     * Handles the expand/collapse event for a creative placement row.
     * @param {*} event - The expand/collapse event.
     */
    onExpandClick = (event) => {
        if (event?.expanded) {
            const node = event.node;
            if(!node.data.nested) {
                this.loadCreatives(node.data);
            }
        }
    }

    render() {
        return (
            <>
                    <div className="orphaned-delivered-container">
                        <div className="orphaned-delivered-right-container">
                            <div className="orphaned-title-container">
                            {this.props.isCreative &&
                                <>
                                    <p className="orphaned-title">Creatives</p>
                                    <p className="orphaned-description">Select creative(s) from the table below to map with placements</p>
                                </>}
                            {
                                !this.props.isCreative &&
                                <>
                                    <p className="orphaned-title">Unmapped delivered objects</p>
                                    <p className="orphaned-description">Choose unmapped delivered objects that you would like to map to available placemements</p></>
                            }
                            </div>
                            <div className="orphaned-delivered-table-container">
                                {!this.props.isCreative && 
                                <OmniToolbarComponent slot="header" className='orphaned-table-toolbar'>

                                    <div slot="end" className="orphaned-toolbar-menu">
                                        <button className="secondary" disabled={this.state.enableMapToObject} onClick={this.handleMultipleMapping}>Map</button>
                                        <div className="toolbar-icon-group">
                                            <div className="toolbar-divider" />
                                            {/* <button className="tertiary">
                                                <OmniIconComponent className='is-size-4' icon-id="omni:interactive:importExport" />
                                            </button> */}

                                            <OmniSearchComponent ph="Search" onSearchUpdate={(event)=>this.updateSearch(event, this.props.isCreative ? 'creative' : 'orphaned')}/>
                                            <div className="toolbar-divider" />
                                            <OrphanedFilterComponent filterDropdownOptions={this.state.filterDropdownOptions} onApplyFilter={this.applyFilter.bind(this, 'orphaned')}/>
                                        </div>
                                    </div>
                                </OmniToolbarComponent> }
                                
                                {this.state.isOrphanedTableLoading 
                                ? this.displaySkeletonTable()
                                : this.state.orphanedTableData.length ? 
                                (!this.props.isCreative ? 
                                <OmniTableComponent
                                    keyFn={(row) => row}
                                    expandAllOnLoad={true}
                                    id="orphaned-delivered-table"
                                    data={this.state.orphanedTableData}
                                    onSortUpdate={this.updateSortColumn}
                                    sort={this.state.sort['orphanedSort']}
                                    columns={this.orphanedLeftColumns}
                                    key={this.state.orphanedTableData.length}
                                    optimize={true}
                                /> : 
                                    <div style={{ width: "100%", height: '100%' }}>
                                        <AgGridReact
                                            key={this.state?.orphanedTableData.length}
                                            ref={this.creativeGridRef}
                                            columnDefs={this.creativeColumnDefs}
                                            rowData={this.state.orphanedTableData}
                                            getRowId={(params) => params?.data?.id}
                                            rowSelection={{mode: "multiRow"}}
                                            onSelectionChanged={this.onCreativeSelection}
                                            defaultColDef={this.defaultColDef}
                                            domLayout="normal"
                                        />
                                    </div> )
                            : <NoDataComponent
                                heading={"No Data Found"}
                                message={"No Orphaned Placements found!"}
                            />}
                            </div>
                        </div>
                        <div className="actionButtons">
                            <button className="secondary" style={{"marginBottom": "20px"}} disabled={this.state.enableMapToObject} onClick={this.handleMultipleMapping}>Map</button>
                            <button className="secondary" disabled={this.state.disableUnMap} onClick={this.unMapCreatives}>Unmap</button>
                        </div>
                        <div className="orphaned-delivered-left-container">
                            <div className="orphaned-title-container">
                                <p className="orphaned-title">Available placements</p>
                                {this.props.isCreative && <p className="orphaned-description">Table below contains available placements for mapping</p>}
                                {!this.props.isCreative && <p className="orphaned-description">This table combines all available placements and the mapped orphaned objects</p>}
                            </div>
                            <div className="orphaned-placement-table-container">
                                {!this.props.isCreative && 
                                <OmniToolbarComponent slot="header" className='orphaned-table-toolbar'>
                                <div slot="end" className="orphaned-toolbar-menu">
                                    {this.props.isCreative &&
                                        <button className="secondary" disabled={this.state.disableUnMap} onClick={this.unMapCreatives}>Unmap</button>
                                    }
                                    <div className="toolbar-icon-group">
                                        <div className="toolbar-divider" />
                                        {/* <button className="tertiary">
                                                <OmniIconComponent className='is-size-4' icon-id="omni:interactive:importExport" />
                                            </button> */}
                                        <OmniSearchComponent ph="Search" onSearchUpdate={(event) => this.updateSearch(event, 'placement')}/>
                                        <div className="toolbar-divider" />
                                        <PlacementFilterComponent onApplyFilter={this.applyFilter.bind(this, 'placement')} />
                                    </div>
                                </div>
                                </OmniToolbarComponent> }
                                <OmniTooltipNextComponent class="exportIcon">
                                    <div slot="content">
                                        Export Mapped Creatives
                                    </div>
                                    <OmniIconComponent slot="invoker" aria-hidden="false" icon-id="omni:interactive:export" onClick={this.exportCreativePlacements}></OmniIconComponent>
                                </OmniTooltipNextComponent>
                                {this.state.isPlacementTableDataLoading 
                                ?  this.displaySkeletonTable()
                                : this.state.placementTableData.length || this.state.creativePlacementData.length ? 
                                (!this.props.isCreative ?
                                <OmniTableComponent
                                    keyFn={(row) => row}
                                    expandAllOnLoad={true}
                                    id="orphaned-placement-table"
                                    data={this.state.placementTableData}
                                    onSortUpdate={this.updateSortColumn}
                                    sort={this.state.sort['placementSort']}
                                    columns={this.placementLeftColumns()}
                                    key={this.state.orphanedTableData.length}
                                    optimize={true}
                                /> : 
                                    <div style={{ width: "100%", height: '100%' }}>
                                        <AgGridReact
                                            key={this.state?.creativePlacementData.length}
                                            ref={this.creativePlacementGridRef}
                                            treeData={true}
                                            treeDataChildrenField={"creatives"}
                                            onRowGroupOpened={this.onExpandClick}
                                            columnDefs={this.creativePlacementColumnDefs}
                                            rowData={this.state.creativePlacementData}
                                            getRowId={(params) => params?.data?.id}
                                            rowSelection={{
                                                mode: "multiRow",
                                                groupSelects: "descendants",
                                                hideDisabledCheckboxes: true,
                                                checkboxLocation: "autoGroupColumn",
                                                checkboxes: (node) => {
                                                    return node.data.dummyChild ? false : true;
                                                }
                                            }}
                                            onSelectionChanged={this.onCreativePlacementSelection}
                                            defaultColDef={this.defaultColDef}
                                            sideBar={true}
                                            domLayout="normal"
                                            groupDisplayType={"custom"}
                                        />
                                    </div> )
                                : <NoDataComponent
                                    heading={"No Data Found"}
                                    message={"No Placements found!"}
                                />}
                            </div>
                            <div className="indicators">
                                <span className="color"></span>
                                <span className="text">Mapped Creatives</span>
                            </div>
                        </div>
                    </div>
                    <div className="orphaned-delivered-actionButtons">
                        <button onClick={this.handleSaveButton}>
                            <span className="close-text">Close</span>
                        </button>
                    </div>
                <OrphanedDeliveredModelComponent 
                closeModel={this.closeModel} 
                isModelOpen={this.state.isModelOpen}
                mappingObjects={this.mappingObjects}
                omniProfile={this.props.omniProfile}
                campaignObj={this.props?.state?.campaignObj}
                setSpinnerCount={this.props.setSpinnerCount} 
                fetchPlacementTableData={this.fetchPlacementTableData}
                fetchOrphanedDeliveredData={this.fetchOrphanedDeliveredData} 
                fetchCreatives={this.fetchCreatives}
                setEnableMapToObject={(value) => this.setState({ enableMapToObject: value })}
                placementsData={this.state.placementsData}
                orphanedDataArray={this.state.orphanedDataArray}
                campaignDropdownOptions={this.campaignDropdownOptions}
                placementDropdownOptions={this.placementDropdownOptions}
                />
               
            </>
        )
    }
};